import { Box, Stack, useMediaQuery, Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import RevaText from "./RevaText";

export default function DownloadAppCTA() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        mt: 6,
        p: 4,
        borderRadius: 2,
        backgroundColor: "black",
        textAlign: "center",
      }}
    >
      <Stack direction="row" justifyContent="center" spacing={2}>
        {isDesktop && (
          <Box
            component="img"
            src="/img/reva-qr.png" // asegurate de tenerlo en public/
            alt="QR para descargar Reva"
            sx={{ height: 140, borderRadius: 2 }}
          />
        )}
        <Stack sx={{ maxWidth: 400 }}>
          <RevaText variant="h5" fontWeight={600} id="¿Quieres participar en eventos como este?" />
          <RevaText
            variant="body1"
            color="text.secondary"
            sx={{ my: 2 }}
            id="Descarga la app Reva para registrarte en torneos, ver rankings y más."
          />

          {/* Botones de descarga */}
          <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
            <MuiLink
              href="https://play.google.com/store/apps/details?id=py.com.kynox.pelotajara"
              target="_blank"
              rel="noopener"
            >
              <Box
                component="img"
                src="/img/google-play-badge.png"
                alt="Disponible en Google Play"
                sx={{ height: 40 }}
              />
            </MuiLink>
            <MuiLink href="https://apps.apple.com/app/id1312023245" target="_blank" rel="noopener">
              <Box
                component="img"
                src="/img/app-store-badge-white.svg"
                alt="Disponible en App Store"
                sx={{ height: 40 }}
              />
            </MuiLink>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
